import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import type React from "react";
import { Link } from "react-router-dom";

import { type LeftSidebarType } from "@/components/NewDesign/LeftSidebar.tsx";

export default function VerticalLinks({ links }: { links: LeftSidebarType[] }) {
  if (!links || links.length === 0) {
    return <></>;
  }

  const baseSx = {
    p: 0.5,
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    height: "40px",
    borderRadius: 2,
    cursor: "pointer",
    bgcolor: "transparent",
  };

  return (
    <Box sx={{ p: 1 }}>
      {links.map((linkItem, index) => (
        <Box
          key={linkItem.id}
          sx={{
            ...(index !== links.length - 1 && { mb: 1 }),
            position: "relative",
          }}
        >
          <Tooltip title={linkItem?.label} placement="right" arrow>
            <Box>
              {linkItem?.url && !linkItem.disabled && (
                <Box
                  component={Link}
                  to={linkItem.url}
                  onClick={(e) => {
                    if (linkItem.active) {
                      e.preventDefault();
                      return;
                    }
                    linkItem.onClick?.();
                  }}
                  sx={{
                    ...baseSx,
                    textDecoration: "none",
                    ...(linkItem.active
                      ? { bgcolor: "var(--color-brand-primary)", color: "#fff" }
                      : {
                          color: "var(--color-zinc-300)",
                          "&:hover": { bgcolor: "var(--color-zinc-800)" },
                        }),
                  }}
                  aria-label={linkItem.label}
                >
                  {linkItem?.hasUnreads && (
                    <Box
                      sx={{
                        bgcolor: "#ef4444",
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        display: "inline-flex",
                        position: "absolute",
                        left: "-4px",
                        top: "-4px",
                        boxShadow: "0 0 0 2px rgba(0,0,0,0.5)",
                      }}
                    />
                  )}
                  {linkItem?.icon ? linkItem.icon : linkItem.label}
                </Box>
              )}

              {linkItem?.url && linkItem.disabled && (
                <Box
                  sx={{
                    ...baseSx,
                    textDecoration: "none",
                    cursor: "not-allowed",
                    opacity: 0.45,
                    color: "var(--color-zinc-500)",
                  }}
                  aria-disabled="true"
                  aria-label={linkItem.label}
                >
                  {linkItem?.hasUnreads && (
                    <Box
                      sx={{
                        bgcolor: "#ef4444",
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        display: "inline-flex",
                        position: "absolute",
                        left: "-4px",
                        top: "-4px",
                        boxShadow: "0 0 0 2px rgba(0,0,0,0.5)",
                        opacity: 0.5,
                      }}
                    />
                  )}
                  {linkItem?.icon ? linkItem.icon : linkItem.label}
                </Box>
              )}

              {linkItem?.component && (
                <Box
                  onClick={() => linkItem.onClick?.()}
                  sx={{
                    ...baseSx,
                    ...(linkItem.active
                      ? { bgcolor: "var(--color-brand-primary)", color: "#fff" }
                      : {
                          color: "var(--color-zinc-300)",
                          "&:hover": { bgcolor: "var(--color-zinc-800)" },
                        }),
                  }}
                  aria-label={linkItem.label}
                >
                  {linkItem.component}
                </Box>
              )}

              {!linkItem?.component && !linkItem?.url && (
                <Box
                  component="button"
                  onClick={() => {
                    linkItem.onClick?.();
                  }}
                  sx={{
                    ...baseSx,
                    border: "none",
                    ...(linkItem.bgSx
                      ? { ...linkItem.bgSx, color: "#fff" }
                      : linkItem.active
                        ? { bgcolor: "var(--color-brand-primary)", color: "#fff" }
                        : {
                            color: "var(--color-zinc-300)",
                            "&:hover": { bgcolor: "var(--color-zinc-800)" },
                          }),
                  }}
                  aria-label={linkItem.label}
                >
                  {linkItem?.icon ? linkItem.icon : linkItem.label}
                </Box>
              )}
            </Box>
          </Tooltip>
        </Box>
      ))}
    </Box>
  );
}
